/*
 * Copyright 2020 Autodesk, Inc.  All rights reserved.
 * This computer source code and related instructions and
 * comments are the unpublished confidential and proprietary
 * information of Autodesk, Inc. and are protected under
 * applicable copyright and trade secret law.  They may not
 * be disclosed to, copied or used by any third party without
 * the prior written consent of Autodesk, Inc.
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import { tealiumUrl } from './App/App.config';
import { loadScriptFromUrl } from './utils';

loadScriptFromUrl(tealiumUrl, true);

const trigger = document.getElementById('root');

if (trigger)
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    trigger,
  );
else console.log("Can not find 'root' id to anchor Contact Widget");
